var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-input',{attrs:{"placeholder":"Filtrar persona / empresa","size":"sm"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})
}
var staticRenderFns = []

export { render, staticRenderFns }